import { gsap } from "gsap/dist/gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const Common = () => {
  $(window).on("scroll", function () {
    // scrollでheaderにbox-shadowを付与
    if ($(this).scrollTop() > 1) {
      $(".l-header").addClass("is--fixed");
    } else {
      $(".l-header").removeClass("is--fixed");
    }

    // to-top を表示かどうか
    if ($(this).scrollTop() > 100) {
      $(".js-to-top").addClass("is--show");
    } else {
      $(".js-to-top").removeClass("is--show");
    }
  });

  // header-toggle
  $(".js-header-toggle-button").on("click", () => {
    $(".js-header-toggle").toggleClass("is--open");
  });

  // to top animation
  $(".js-to-top").on("click", function () {
    $("body,html").animate(
      {
        scrollTop: 0,
      },
      1000
    );
    return false;
  });

  $('a[href^="#"]').on("click", function () {
    const speed = 700;
    const header_height = $("header").height();
    const href = $(this).attr("href");
    const target = $(href == "#" || href == "" ? "html" : href);
    const position = target.offset().top - header_height;
    $("body,html").animate({ scrollTop: position }, speed, "swing");
    return false;
  });
};

